<template>
  <div class="od-card">
    <div class="od-card-header">
      <div class="od-card-header-left">
        <a-icon type="shopping" class="od-card-header-icon" />
        <p class="od-card-header-title">
          Informasi Pembelian
        </p>
      </div>
    </div>
    <div class="od-card-body">
      <div class="od-info-grid">
        <span class="od-info-label">Nomor Transaksi</span>
        <div class="od-flex od-flex-center od-gap-2">
          <span class="od-mono od-font-bold">{{ order.order_number || order.po_number || order.id }}</span>
          <button class="od-copy-btn" @click="copyToClipboard(String(order.order_number || order.po_number || order.id), 'Nomor Transaksi')">
            <a-icon type="copy" /> Salin
          </button>
        </div>

        <span class="od-info-label">Status Pembayaran</span>
        <div>
          <span class="od-badge" :class="paymentBadgeClass">{{ paymentStatusLabel }}</span>
        </div>

        <span class="od-info-label">Tanggal Transaksi</span>
        <span class="od-info-value">{{ formatDate(order.created_at || order.order_date) }}</span>

        <span class="od-info-label">Total Pembayaran</span>
        <span class="od-info-value od-font-bold">{{ toCurrency(order.gross_total) }}</span>

        <template v-if="isGuest">
          <span class="od-info-label">Email</span>
          <span class="od-info-value">{{ order.customer_email || (order.billing_data && order.billing_data.email) || order.email || '-' }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderPurchaseInfo',
  props: {
    order: { type: Object, default: null },
    isGuest: { type: Boolean, default: false },
    toCurrency: { type: Function, required: true },
    formatDate: { type: Function, required: true },
    getPurchaseStatusClass: { type: Function, required: true },
    getPaymentStatusLabel: { type: Function, required: true },
    copyToClipboard: { type: Function, required: true },
  },
  computed: {
    paymentBadgeClass() {
      return this.getPurchaseStatusClass(this.order.payment_state)
    },
    paymentStatusLabel() {
      return this.getPaymentStatusLabel(this.order.payment_state)
    },
  },
}
</script>
